(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('ClientCreditsUseModalController', ClientCreditsUseModalController);

        ClientCreditsUseModalController.$inject = ['$uibModalInstance', 'ClientService', 'clientCredits', 'credit', 'toastr'];

    function ClientCreditsUseModalController($uibModalInstance, ClientService, clientCredits, credit, toastr) {
        var vm = this;

        vm.credit       = credit;
        vm.formatDate   = formatDate;
        vm.ok           = ok;
        vm.cancel       = cancel;

        function formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        }

        activate();

        function activate() {
        }

        function ok () {
            let data = {};
            data['used_at'] = moment().format();
            data['total_used'] = vm.credit.total;
            ClientService.useClientCredit(vm.credit.id, data).then(function(response, status) {
                if(response.status !== 200) {
                    toastr.error("An error ocurred on set to used this credit");
                } else {
                    toastr.success("Client credit successfully updated!");
                    clientCredits.getByFilter();
                    $uibModalInstance.close();
                }
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();